import { render, staticRenderFns } from "./ListVeiculo.vue?vue&type=template&id=89ee5ae4"
import script from "./ListVeiculo.vue?vue&type=script&lang=js"
export * from "./ListVeiculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports